import { render, staticRenderFns } from "./SampleOne.vue?vue&type=template&id=297a91ac&scoped=true&"
import script from "./SampleOne.vue?vue&type=script&lang=js&"
export * from "./SampleOne.vue?vue&type=script&lang=js&"
import style0 from "./SampleOne.vue?vue&type=style&index=0&id=297a91ac&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a91ac",
  null
  
)

export default component.exports